import { combineReducers } from 'redux';
import loading from './loading';
import error from './error';
import contact from './contact';
import cart from './cart';
import payment from './payment';
import auth from './auth';
import prefecture from './prefecture';
import transaction from './transaction';
import mypage from './mypage';
import product from './product';

export default combineReducers({
  loading,
  error,
  contact,
  cart,
  payment,
  auth,
  prefecture,
  transaction,
  mypage,
  product,
});
